import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { useFormikContext, Field } from 'formik';
import { Select } from '../../Select/component.js';
import { Icon } from '../../Icon/component.js';
var _excluded = ["customValidityMessage", "validators", "label", "labelTooltip", "onChange", "changeHandler"];
var SelectField = function SelectField(_ref) {
  var _rest$options;
  _ref.customValidityMessage;
  _ref.validators;
  _ref.label;
  _ref.labelTooltip;
  var onChange = _ref.onChange,
    changeHandler = _ref.changeHandler,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (!useFormikContext()) {
    throw Error('The <SelectField /> component must be wrapped in a Formik context.  Did you mean to use the Core.Select instead?');
  }
  var setField = function setField(e) {
    onChange === null || onChange === undefined || onChange(e);
    changeHandler === null || changeHandler === undefined || changeHandler(e);
  };
  return /*#__PURE__*/React.createElement(Field, _extends({
    as: Select,
    onChange: function onChange(e) {
      return setField(e);
    },
    placeholder: rest.placeholder,
    icon: /*#__PURE__*/React.createElement(Icon, {
      prefix: "fas",
      iconName: "sort",
      size: "xs"
    })
  }, rest), (_rest$options = rest.options) === null || _rest$options === undefined ? undefined : _rest$options.map(function (_ref2) {
    var value = _ref2.value,
      text = _ref2.text;
    return /*#__PURE__*/React.createElement("option", {
      key: value,
      value: value
    }, text);
  }));
};
SelectField.displayName = "SelectField";
export { SelectField };